// extracted by mini-css-extract-plugin
export default {"background":"SecondSection_background__Db85W"};